import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

interface QuickActionButtonProps {
  title: string;
  description: string;
  icon: SvgIconComponent;
  isDarkMode?: boolean;
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  onClick: () => void;
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const QuickActionButton: React.FC<QuickActionButtonProps> = ({
  title,
  description,
  icon: Icon,
  isDarkMode = false,
  color = 'secondary',
  onClick,
  fullWidth = true,
  size = 'large'
}) => {
  return (
    <Button
      fullWidth={fullWidth}
      variant="text"
      size={size}
      color={isDarkMode ? 'primary' : color}
      startIcon={<Icon />}
      onClick={onClick}
      sx={{
        justifyContent: 'flex-start',
        py: 2,
        borderWidth: 2,
        '&:hover': { borderWidth: 2 }
      }}
    >
      <Box sx={{ textAlign: 'left', ml: 1 }}>
        <Typography variant="body2" fontWeight={800}>
          {title}
        </Typography>
        <Typography variant="caption" fontWeight={400} color="text.secondary">
          {description}
        </Typography>
      </Box>
    </Button>
  );
};

export default QuickActionButton;